import { useEffect } from 'react';

export const useKeyboardVisible = () => {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const handleResize = () => {
      const taskContent = document.getElementById('task-content-container');

      if (taskContent) {
        const heightDiff = window.innerHeight - viewport.height;
        taskContent.style.marginBottom = `${heightDiff > 150 ? heightDiff : 0}px`;
      }
    };

    viewport.addEventListener('resize', handleResize);
    handleResize();

    return () => viewport.removeEventListener('resize', handleResize);
  }, []);
};
